module.exports = __webpack_public_path__ + "static/pizza-bc38b919120b72f7bc2dec3749b3f602.gif";